import { Component, Mixins, Watch } from "vue-property-decorator";
import { HorizontalBar, mixins } from "vue-chartjs";
import {
  CANVAS_COLOR_PLUGIN,
  LABEL_CHART_DRAW,
  generalOptions
} from "../../../constants/AdminDashboardConstants";
import { Utils } from "@/shared/utils/utils";
import { ChartOptions } from "chart.js";
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
const { reactiveProp } = mixins;

@Component({
  name: "HorizontalBarChart"
})
export default class HorizontalBarChart extends Mixins(
  HorizontalBar,
  reactiveProp
) {
  options: ChartOptions = {
    ...generalOptions,
    onClick: this.handleClick,
    plugins: {
      datalabels: {
        backgroundColor: function(context) {
          /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
          return context.dataset.backgroundColor as any;
        },
        borderColor: "white",
        borderRadius: 20,
        borderWidth: 2,
        anchor: "end",
        color: "white",
        font: {
          weight: "bold"
        },
        padding: 1
      }
    },
    maintainAspectRatio: false
  };

  mounted() {
    this.addPlugin(ChartJSPluginDatalabels);
    this.addPlugin(CANVAS_COLOR_PLUGIN);
    this.addPlugin(LABEL_CHART_DRAW);
    Utils.setBackgroundColors(this.chartData);
    this.renderChart(this.chartData, this.options);
  }

  handleClick(point: MouseEvent, event: { _index: number }[]) {
    if (event.length === 0) {
      this.$emit("chartClickOut", true);
    } else if (event[0]) {
      const index = event[0]._index;
      const label = (this.chartData.labels as string[] | number[])[index];
      this.$emit("chartClick", label);
    }
  }

  @Watch("chartData")
  updateChart() {
    Utils.setBackgroundColors(this.chartData);
    this.renderChart(this.chartData, this.options);
  }
}
